import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { purchaseReports,purchaseExcel } from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Modal } from 'react-bootstrap';
import { viewPurchaseBill } from '../../../redux/actions/Billing.action';
import { VscTarget } from 'react-icons/vsc';
import * as XLSX from 'xlsx';
import ReactPaginate from 'react-paginate';

export default function PurchaseReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  const billData = useSelector((state) => state.bills);
  const [reportModal, setReportModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const limits = {
    page: currentPage,
    limit: itemsPerPage
  }

  const reportToggle = () => {
    setReportModal(!reportModal);
  };
  console.log('reportData', reportData?.purchaseReport?.data);

  const [formData, setFormData] = useState({
    date: '',
    startDate: '',
    endDate: '',
    type: '',
    paymentType: '',
    search: '',
  });

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || '',
      ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
      ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
    }));
  };
  const handleView = (pId) => {
    dispatch(viewPurchaseBill(pId));
  };

  useEffect(() => {
    let payload = {};
    if (formData.date) {
      payload.date = formData.date;
    } else {
      payload.date = '';
    }

    if (formData.startDate || formData.endDate) {
      payload.startDate = formData.startDate;
      payload.endDate = formData.endDate;
    } else {
      payload.startDate = '';
      payload.endDate = '';
    }

    if (formData) {
      payload.page = currentPage;
      payload.limit = itemsPerPage;
      payload.search = formData.search;
      dispatch(purchaseReports(payload, limits));
      dispatch(purchaseExcel(payload));
    }

  }, [formData, currentPage, itemsPerPage]);
  
  const filteredData = reportData?.purchaseReport?.data?.data || [];
  const totalCount = reportData?.purchaseReport?.data?.totalCount || 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [formData.search]);

  // Handle Page Change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1); // ReactPaginate starts from 0
  };

  const handleDownload = () => {
    if (!billData?.purchaseExcel?.data?.data || billData?.purchaseExcel?.data?.data.length === 0) {
          alert('No data available to download!');
          return;
        }
    const tableData = billData?.purchaseExcel?.data?.data.map((res) => ({
      'Party Name': res.partyName,
      'Tax Type': res.taxType,
      'GST Apply': res.gstApply,
      'Invoice Type': res.invoiceType,
      'Bill No': res.billNo,
      'Bill Date': res.billDate
        ? new Date(res.billDate).toLocaleDateString('en-GB')
        : '',
      'Inward No': res.inwardNo,
      'Basic Amount': res.basicAmount,
      SGST: res.sgst,
      CGST: res.cgst,
      'Discount (%)': res.cDiscount || '-',
      'Discount Amount': res.discountAmount || '-',
      'Offer Amount': res.offerAmount || '-',
      'Rounding Amount': res.roundingAmount || '-',
      'Bill Amount': res.billAmount,
      Remark: res.remark,
    }));

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Purchase Report');

    XLSX.writeFile(workbook, 'Purchase_Report.xlsx');
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-3">
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white"
            >
              Download
            </Button>
          </div>
        </div>

        <div className="col-6 text-end ms-auto mt-4">
          <div className="flex justify-end gap-3 font-medium text-lg">
            <label className="text-center block text-success border-r pe-3">
              <span>Purchase Amount : </span>{' '}
              <span className="ms-1 border-b border-success">
                {reportData?.purchaseReport?.data?.totalPurchaseAmount?.toFixed(
                  2,
                )}
              </span>
            </label>
            <div className="">
              Total Records:{' '}
              <span className="text-success border-b border-success">
                {reportData?.purchaseReport?.data?.totalCount || 0}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Bill Date</Th>
                <Th>Party Name</Th>
                <Th>Tax Type</Th>
                <Th>GST Apply</Th>
                <Th>Invoice Type</Th>
                <Th>Bill No</Th>
                <Th>Inward No</Th>
                <Th>Basic Amount</Th>
                <Th>SGST</Th>
                <Th>CGST</Th>
                <Th>Discount (%)</Th>
                <Th>Discount Amount</Th>
                <Th>Offer Amount</Th>
                <Th>Rounding Amount</Th>
                <Th>Bill Amount</Th>
                <Th>Remark</Th>
                <Th className="text-end sticky right-0 bg-white">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData?.length > 0 ? (
                filteredData?.map((res, index) => {
                  return (
                    <Tr key={index}>
                      <Td>
                        {res.billDate
                          ? new Date(res.billDate).toLocaleDateString('en-GB')
                          : ''}
                      </Td>
                      <Td className='capitalize'>{res.partyName}</Td>
                      <Td>{res.taxType}</Td>
                      <Td>{res.gstApply}</Td>
                      <Td>{res.invoiceType}</Td>
                      <Td>{res.billNo}</Td>
                      <Td>{res.inwardNo}</Td>
                      <Td>{res.basicAmount}</Td>
                      <Td>{res.sgst}</Td>
                      <Td>{res.cgst}</Td>
                      <Td>{res.cDiscount || '-'}</Td>
                      <Td>{res.discountAmount || '-'}</Td>
                      <Td>{res.offerAmount || '-'}</Td>
                      <Td>{res.roundingAmount || '-'}</Td>
                      <Td>{res.billAmount}</Td>
                      <Td className='capitalize'>{res.remark}</Td>
                      <Td
                        style={{
                          minWidth: '100px',
                          position: 'sticky',
                          right: '0',
                          backgroundColor: 'white',
                        }}
                      >
                        <div className="d-flex gap-3 justify-center">
                          <VscTarget
                            onClick={() => {
                              reportToggle();
                              handleView(res._id);
                            }}
                            className="cursor-pointer text-primary fs-5"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Td colSpan={29} textAlign={'center'}>
                    No any report
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      {filteredData?.length > 0 && (
        <>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageChange}
            pageRangeDisplayed={10}
            pageCount={totalPages}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            className="pagination"
            forcePage={currentPage - 1}
          />
        </>
      )}

      <Modal show={reportModal} onHide={reportToggle} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Product Report</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div className="table-responsive">
            <table className="table table-bordered p-0">
              <thead>
                <tr className="text-center text-sm">
                  <th className="min-w-[300px]">Product Name</th>
                  <th className="!min-w-[100px]">HSN Code</th>
                  <th className="!min-w-[100px]">Pack</th>
                  <th className="!min-w-[100px]">MRP</th>
                  <th className="!min-w-[100px]">Batch</th>
                  <th className="!min-w-[100px]">Expire Date</th>
                  <th className="!min-w-[100px]">Qty</th>
                  <th className="!min-w-[100px]">F/N</th>
                  <th className="!min-w-[100px]">Free Qty</th>
                  <th className="!min-w-[100px]">P. Rate</th>
                  <th className="!min-w-[100px]">CD (%)</th>
                  <th className="!min-w-[100px]">Net Rate</th>
                  <th className="!min-w-[100px]">Amount</th>
                  <th className="!min-w-[100px]">InRate</th>
                  <th className="!min-w-[100px]">GST (%)</th>
                </tr>
              </thead>
              <tbody>
                {billData?.viewPurchaseBill?.data?.data?.productList?.length >
                0 ? (
                  billData?.viewPurchaseBill?.data?.data?.productList?.map(
                    (res) => {
                      return (
                        <tr>
                          <td className="uppercase">{res.productName}</td>
                          <td>{res.hsnCode}</td>
                          <td className="uppercase">{res.pack}</td>
                          <td>{res.mrp}</td>
                          <td>{res.batchNo}</td>
                          <td>{res.expDate}</td>
                          <td>{res.qty}</td>
                          <td>{res.fn}</td>
                          <td>{res.fQty}</td>
                          <td>{res.pRate}</td>
                          <td>{res.discount}</td>
                          <td>{res.netRate}</td>
                          <td>{res.amount}</td>
                          <td>{res.inRate}</td>
                          <td>{res.gst}</td>
                        </tr>
                      );
                    },
                  )
                ) : (
                  <tr>
                    <td colSpan={14}>No any data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={reportToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
